import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import FadeIn from "@/components/FadeIn";

const FAQS = [
  {
    q: "Quel est le prix d'une climatisation Daikin installée ?",
    a: "Un monosplit Daikin (une pièce) est posé dès 2 500 €, pose et mise en service comprises. Pour plusieurs pièces (bisplit, multisplit ou gainable), le prix dépend du nombre d'unités, des longueurs de liaison et de la configuration du logement : nous chiffrons précisément après une étude gratuite à domicile.",
  },
  {
    q: "Combien de temps dure l'installation ?",
    a: "Nous intervenons sous 15 jours après validation du devis. La pose d'un monosplit se fait généralement en une journée ; un multisplit peut demander une à deux journées selon le nombre d'unités et le passage des liaisons.",
  },
  {
    q: "Pourquoi choisir Daikin ?",
    a: "Daikin est le leader mondial de la climatisation : fiabilité éprouvée, unités intérieures très silencieuses (dès 19 dB(A) selon modèle), technologie Inverter économe et application Onecta pour piloter à distance. Nous sommes installateurs Daikin et connaissons parfaitement la gamme.",
  },
  {
    q: "Une climatisation réversible fait-elle vraiment économiser sur le chauffage ?",
    a: "Oui. En mode chauffage, une pompe à chaleur air/air Daikin restitue 3 à 4 kWh de chaleur pour 1 kWh d'électricité consommé. C'est un appoint de chauffage très économique en mi-saison et en hiver doux, typique du Sud-Ouest, en remplacement de convecteurs électriques.",
  },
  {
    q: "Faites-vous appel à des sous-traitants ?",
    a: "Jamais. L'étude, la pose, la mise en service et le SAV sont réalisés par les techniciens salariés d'Ener Solutions. Vous avez un interlocuteur unique, basé à Saint-André-de-Cubzac, et un SAV qui intervient sous 48 h.",
  },
  {
    q: "Dans quelles zones intervenez-vous ?",
    a: "En Gironde, Charente, Charente-Maritime, Dordogne, Lot-et-Garonne et Landes, depuis notre bureau de Saint-André-de-Cubzac (33240).",
  },
];

export default function ClimFaq() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" data-testid="clim-section-faq" className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <FadeIn>
          <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.25em] text-ice sm:text-xs">
            FAQ
          </p>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-ink sm:text-5xl">
            Vos questions, nos réponses.
          </h2>
        </FadeIn>

        <div className="mt-12 divide-y divide-glacier-border border-y border-glacier-border">
          {FAQS.map((f, i) => {
            const open = openIdx === i;
            return (
              <FadeIn key={i} delay={i * 0.04}>
                <div data-testid={`clim-faq-item-${i}`}>
                  <button
                    data-testid={`clim-faq-toggle-${i}`}
                    onClick={() => setOpenIdx(open ? -1 : i)}
                    className="flex min-h-[56px] w-full items-center justify-between gap-6 py-6 text-left"
                  >
                    <span className="font-display text-base font-bold text-ink sm:text-lg">{f.q}</span>
                    <Plus
                      className={`h-5 w-5 shrink-0 text-ice transition-transform duration-300 ${
                        open ? "rotate-45" : ""
                      }`}
                    />
                  </button>
                  <AnimatePresence initial={false}>
                    {open && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
                        className="overflow-hidden"
                      >
                        <p className="pb-6 pr-10 text-sm leading-relaxed text-slate-600">{f.a}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </FadeIn>
            );
          })}
        </div>
      </div>
    </section>
  );
}
